import React from 'react'
import DateRangePicker from './DateRangePicker'

interface DateFilterButtonProps {
  value?: {
    startDate: Date | string | null
    endDate: Date | string | null
  }
  onChange?: (value: {
    startDate: Date | string | null
    endDate: Date | string | null
  }) => void
  onClear?: () => void
  isRTL?: boolean
  shouldCloseOnSelect?: boolean
}

const DateFilterButton: React.FC<DateFilterButtonProps> = (props) => {
  return <DateRangePicker {...props} />
}

export default DateFilterButton
